// approvalService.js


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class ApprovalService {
  async sendDiscountApproval(notificationData) {
   

  

    try {
       //console.log("Token",localStorage.getItem('authToken'));
     const response = await fetch(`${API_BASE_URL}/admin/discount-approval`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(notificationData),
        });


      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to send notification");
      }

      return await response.json();
    } catch (error) {
      console.error("Error sending approval request:", error);
      throw error;
    }
  }
}

const approvalService = new ApprovalService();
export default approvalService;
